import { ColorsType } from '~/theme/model/themeModel';
import * as colorsBase from './colorsBase';

export const colorsBw: ColorsType = {
	...colorsBase,
	productDetailsBackground: '#F7F6F3',

	metaMenuDefaultBackgroundColor: '#F7F6F3',
};
